import {
  getApiSamplesV1SamplesListRetrieveQueryKey,
  SampleType,
  useApiSamplesV1SamplesCreate,
  useQueryClient,
} from 'api';
import { useNotification, useSiteMaterial } from 'features';
import { useTranslation } from 'i18n';
import { Suspense } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ActionRow, Button, CardsListSkeleton, Grid, Menu, MenuItem, Page, Section } from 'ui';
import { ArrowDropDown } from 'ui/icons';

import { SampleList } from '../../components/SampleList/SampleList';
import { SiteHeader } from '../../components/SiteHeader/SiteHeader';

export const Samples = () => {
  const { t } = useTranslation('orders');
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const { open } = useNotification();
  const { data: siteMaterial } = useSiteMaterial();
  const { mutate: createSample } = useApiSamplesV1SamplesCreate({
    mutation: {
      onError: (error) =>
        open({
          message: t('samplesPage.notifications.createError', { values: { error: String(error) } }),
          type: 'error',
        }),
      onSuccess: ({ id }) => {
        open({
          message: t('samplesPage.notifications.sampleCreated'),
          type: 'success',
        });
        queryClient.invalidateQueries({ queryKey: getApiSamplesV1SamplesListRetrieveQueryKey(siteMaterial.public_id) });
        navigate(`${id}/edit`);
      },
    },
  });
  const handleCreate = (type: SampleType) => createSample({ data: { site_material_id: siteMaterial.id, type } });

  const options = [
    { label: t('samplesPage.createOptions.manualSample'), onClick: () => handleCreate(SampleType.MG) },
    { label: t('samplesPage.createOptions.aiSample'), onClick: () => handleCreate(SampleType.AG) },
    { disabled: true, label: t('samplesPage.createOptions.labReport'), onClick: () => null },
  ];
  return (
    <Page>
      <Page.Title title={t('samplesPage.pageTitle')} />
      <Page.Divider />
      <Grid container>
        <Grid
          size={{
            md: 4,
            xs: 12,
          }}
        >
          <Section title={t('samplesPage.sections.siteDetails')}>
            <SiteHeader siteMaterial={siteMaterial} />
          </Section>
        </Grid>
        <Grid
          size={{
            md: 8,
            xs: 12,
          }}
        >
          <Section
            title={t('samplesPage.sections.samples')}
            action={
              <ActionRow>
                <Button size="large" fullWidth variant="secondary" component={Link} to="edit">
                  {t('samplesPage.actions.edit')}
                </Button>

                <Menu
                  button={
                    <Button fullWidth size="large" endIcon={<ArrowDropDown />}>
                      {t('samplesPage.actions.create')}
                    </Button>
                  }
                >
                  {options.map((option) => (
                    <MenuItem key={option.label} onClick={option.onClick} disabled={option.disabled}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Menu>
              </ActionRow>
            }
          >
            <Suspense fallback={<CardsListSkeleton />}>
              <SampleList siteMaterialId={siteMaterial.public_id} />
            </Suspense>
          </Section>
        </Grid>
      </Grid>
    </Page>
  );
};
